module.exports = __webpack_public_path__ + "img/m-icon11.254cd0c9.png";